/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createInput, createRole, formData, showRole,
  getRoleList, history,
  creating
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      guard_name: 'administrator',
    };
    createRole(args, ({ data }) => {
      setModal({ isOpen: false });
      getRoleList({ is_paginated: 1, sort_by: 'desc' });
      history.push(`/role-management/${_.get(data, 'id')}`);
      showRole(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };
  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput({ key: 'name', label: 'Name:' }, { required: true, minLength: 3 })}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'page', label: 'Redirect Page:' },
              { required: true }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">{creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}</span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  createRole: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showRole: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_ROLE) > -1
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(CreateModal);
